import { useTitle } from "../helpers"

export default function Home() {

  useTitle('LMOAPPS - Accueil')
  return(
  <>
      <div className="conteneur text-center">
        <h3>Bonjour, voici les citations que nous avons retenus.</h3>
        <br/>
        <p>
            Wikipédia est le plus bel exemple des effets pervers d’internet. On a donné la culture aux imbéciles. Si
            dans le domaine scientifique, les notices sont rédigées par des experts, dans le domaine de la littérature
            et en histoire, c’est un agrégat d’informations nivelées par le plus grand nombre. Il n’y a plus de
            hiérarchisation du savoir. On est à l’époque du relativisme culturel. Tout se vaut. Ainsi la page de Kim
            Kardashian sera bientôt plus longue que celle de Montaigne et le grand poète grec Homère a déjà moins
            d’articles que Homer Simpson.

            Nous sommes en pleine régression intellectuelle” », Laure Joanin, Midi Libre, 31 décembre 2017 -- Dimitri
            Casali
        </p>
        <br/>
        <p>
            La culture, depuis peu, s'écrit avec un C majuscule - ce n'est pas bon signe - on parle de Culture et
            Communication - on pense Culture et Propagande. La culture est devenue un grand mot et une préoccupation
            médiocre. Quand j'entends parler de culture, je sors mon carnet de chèques. Disons d'abord - ce sera plus
            court - ce que la culture n'est pas. Elle n'est pas un devoir. Elle n'est pas une obligation. Elle n'est pas
            un dîner de gala. Elle n'a rien à voir avec le gouvernement. Elle serait plus proche d'une façon d'être,
            d'un coup de foudre, d'une fête toujours inachevée du bonheur - ou peut-être de joie. Elle est une longue
            patience et une tâche infinie - comme l'amour chez Proust, elle est l'espace et le temps rendus sensibles au
            cœur. Elle est plus orgueilleuse et plus modeste que tout ce que l'on pourrait imaginer.

            « La culture vivante », Jean d'Ormesson, Grandes signatures, nº 1, avril 2008, p. 7 -- Jean d'Ormesson
        </p>
        <br/>
        <p>
            C'est peut être la première image qui vient à l'esprit quand on veut suggérer une impression de complexité.
            Et il était délicieux de penser à la mer après tous ces calculs sentimentaux dans une pièce close. Mais ce
            n'était pas à la mer que je voulais penser ; ce n'était pas en ce sens que m'orientait cette longue rêverie
            sur les visages de rêve qui auraient pu apparaître dans mon cadre aux volutes d'or.

            Les Roses de la solitude. - Jacqueline de Romilly
        </p>
        <br/>
        <p>
            C'est une erreur de la géographie que d'avoir attribué l'Espagne à l'Europe ; elle appartient à l'Afrique :
            sang, mœurs, langage, manière de vivre et de combattre en Espagne, tout est africain. Les deux nations ont
            été mêlées trop longtemps, les Carthaginois venus d'Afrique en Espagne, les Vandales passés d'Espagne en
            Afrique, les Maures séjournant en Espagne pendant 700 ans, pour qu'une aussi longue cohabitation pour que
            ces transfusions de peuples et de coutumes n'aient pas confondu ensemble les races et les mœurs des deux
            contrées. Si l'Espagnol était Mahométan, il serait un Africain complet ; c'est la religion qui l'a conservé
            à l'Europe.

            Mémoires historiques sur la révolution d'Espagne (1816), Dominique de Pradt, éd. Perronneau, 1816, p. 70 -
            Dominique de Pradt
        </p>


    </div>

    <br/><br/><br/>

  </>)
}
